import React from 'react';

const HomePage = ({ onNavigate }) => {
  const gameOptions = [
    {
      key: 'single-player',
      icon: '🤖',
      title: 'Single Player',
      description: 'Play against AI',
      action: () => onNavigate('single-player')
    },
    {
      key: 'quick-match',
      icon: '⚡',
      title: 'Quick Match',
      description: 'Find an opponent instantly',
      action: () => onNavigate('matchmaking')
    },
    {
      key: 'create-room',
      icon: '🏠',
      title: 'Create Room',
      description: 'Create a private game room',
      action: () => onNavigate('create-room')
    },
    {
      key: 'join-room',
      icon: '🚪',
      title: 'Join Room',
      description: 'Join an existing game room',
      action: () => onNavigate('join-room')
    },
    {
      key: 'stats',
      icon: '📊',
      title: 'Statistics',
      description: 'View leaderboard and player stats',
      action: () => onNavigate('stats')
    }
  ];

  return (
    <div className="home-container">
      <div className="home-content">
        <h1 className="home-title">🎯 Caro Multiplayer</h1>
        <p className="home-subtitle">Play Caro online with friends worldwide</p>
        
        <div className="home-buttons">
          {gameOptions.map((option) => (
            <button
              key={option.key}
              className="home-button"
              onClick={option.action}
            >
              <div className="icon">{option.icon}</div>
              <div className="title">{option.title}</div>
              <div className="description">{option.description}</div>
            </button>
          ))}
        </div>
        
        <div className="game-rules">
          <h3>How to Play</h3>
          <ul>
            <li>Players take turns placing X and O on the board</li>
            <li>Get 5 pieces in a row (horizontal, vertical, or diagonal) to win</li>
            <li>First player is always X</li>
            <li>Play against AI in single player mode with 3 difficulty levels</li>
            <li>Customize board size and win conditions in private rooms</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default HomePage;
